/**
 * @generated SignedSource<<d3c73b0f91aa3148e9c8a0b92f9986b6>>
 * @relayHash afb1bcdcd6c9f8f47f78c2f9e4127a7f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e1aba776669ac8b5b66be0f76eab46e877b13d3ddc1e942870b0f673bd884577

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e1aba776669ac8b5b66be0f76eab46e877b13d3ddc1e942870b0f673bd884577",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
